import { DEFAULT_REGION_CODE, REGIONS_DATA } from '@/data'

export const fields = `
  ${Object.values(REGIONS_DATA)
    .map(({ code }) => {
      if (code === DEFAULT_REGION_CODE) return ''
      return `
        $language == "${code}" => {
          defined(${code}Title) => {"title": ${code}Title}
        },
      `
    })
    .join('')}
`

export const fragment = (name = 'pageData') => `${name}{${fields}}`

const exported = {
  fields,
  fragment,
}

export default exported
